import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

function Program() {
    return <><Outlet /></>;
}
export default Program;